import styled from 'styled-components';

export const ClearSearchButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 3;
  display: flex;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding-right: 5px;
  em {
    display: none;
  }
  &:hover {
    background-color: rgba(250, 88, 81, 0.1);
    em {
      display: grid;
    }
  }
`;

export const ListItemContent = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
  padding: 8px 20px;
  display: flex;
  cursor: pointer;
  flex: 1;
  z-index: 99999;
  width: calc(100% - 40px);

  path {
    fill: inherit !important;
  }
`;

export const ItemText = styled.div`
  padding-left: 15px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: table-cell;
`;
